import "virtual:fonts.css";
import "./App.scss";

import React, { Suspense, useEffect } from "react";
import { useAtom } from "jotai";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";

import { customerAccessTokenAtom, multipassTokenAtom } from "./atoms/authAtoms";
import { iframeResizeAtom } from "./atoms/iframeResizeAtom";
import LoginForm from "./components/Login";
import Spinner from "./components/Spinner";
import OrderDetail from "./pages/OrderDetail";
import Orders from "./pages/Orders";
import ReturnCancel from "./pages/ReturnCancel";

export type AppProps = {
  customerId?: string;
};

function App({ customerId }: AppProps) {
  const [customerAccessToken, setCustomerAccessToken] = useAtom(
    customerAccessTokenAtom,
  );
  const [multipassToken, setMultipassToken] = useAtom(multipassTokenAtom);

  const [, resizeIframe] = useAtom(iframeResizeAtom);

  const { hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      return;
    }
    const multipassToken = hash.replace("#", "");
    setMultipassToken(multipassToken);
  });

  useEffect(() => {
    const cleanup = resizeIframe();

    return () => {
      cleanup();
      setCustomerAccessToken(null);
    };
  }, [resizeIframe]);

  if (!customerAccessToken && !multipassToken && !hash && !customerId) {
    return (
      <Routes>
        <Route path="/" element={<LoginForm />} />
      </Routes>
    );
  }

  return (
    <Suspense fallback={<Spinner />}>
      <Routes>
        <Route index element={<Navigate to="/orders" replace />} />
        <Route path="/orders" element={<Orders customerId={customerId} />} />
        <Route
          path="/orders/:id"
          element={<OrderDetail customerId={customerId} />}
        />
        <Route path="/orders/:id/return-cancel" element={<ReturnCancel />} />
      </Routes>
    </Suspense>
  );
}

export default App;
